import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

export interface LiveChatUIWelcomeContainerProps {
  children: ReactNode;
  className?: string;
}

export const LiveChatUIWelcomeContainer: FC<
  LiveChatUIWelcomeContainerProps
> = ({ children, className }) => (
  <div
    className={cx(
      "flex flex-1 flex-col items-center justify-center gap-10 overflow-hidden",
      className
    )}
  >
    {children}
  </div>
);
